import React, { useEffect }  from 'react';
import PageLayout from '../components/Layouts/PageLayout';
import { MainData } from '../Data/MainData';
import { Link, Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { getLanLoc } from '../components/Functions/LangFunc';
import styled from 'styled-components';
import PageBuilder from '../components/PageBuilder/PageBuilder';
import { GetDataPromise, PostDataPromise } from '../components/Functions/SendingData';
import { apiMain } from '../App';
import { LoadingFull } from '../components/LoadingFull';
import { IconRouting } from '../Assets/panels/IconRouting';
import { IconBuilding } from '../Assets/contacts/IconBuilding';
import { IconLocation } from '../Assets/contacts/IconLocation';
import { IconAgency } from '../Assets/contacts/IconAgency';
import { DictioneryPanel } from '../Data/DictioneryPanel';
import { formatPrice } from '../components/Functions/Price';
import { TextInputWTitle } from '../components/Inputs/TextInputWTitle';
import { AgeTypeV2Selector } from '../components/Inputs/AgeTypeV2Selector';
import { DateInputWTitle, langDateChangeWithLan } from '../components/Inputs/DateInputWTitle';
import { TextBtn2 } from '../components/Inputs/TextBtn2';
import { SelectInputWTitle } from '../components/Inputs/SelectInputWTitle';
import { IconTick } from '../Assets/panels/IconTick';
import { Dictionery } from '../Data/Dictionery';

const Styles = styled.div`
  display: flex;
  flex-direction: column;
  .success{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: calc(100vh - 200px);
    svg {
      width: 128px;
      height: 128px;
      fill: var(--prime-1);
    }
    .text {
      font-size: 24px;
      font-weight: 600;
      color: var(--prime-1);
      margin-top: 20px;
      text-align: center;
    }
    .action {
      margin-top: 1rem;
      min-width: 150px;
    }
  }
  
`

export default function BuyToursPageSuccess (props){
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams()
  let {isEn: lan, isSet: isSetLan} = getLanLoc(location.pathname);
  if(!props.user.API_TOKEN){
    return (
      <Navigate replace={true} to={`/${(lan ? "en" : "fa")}/tour`}/>
    )
  }
  let lang = lan ? {...MainData.dict[0]} : {...MainData.dict[1]};
  return (
    <PageLayout 
      {...props} 
      language={lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
      dict={MainData.dict} 
      mainLogo={MainData.mainLogo} 
      texts={MainData.texts} 
      nav={MainData.nav} 
      footer={MainData.footer} 
      login={MainData.login}
    >
      <Styles>
        <div className="navpad"></div>
        <div className='success'>
          <IconTick/>
          <div className='text'>
            {DictioneryPanel.packagesDict.requestSent[lang.filename]}
          </div>
          <div className='action'>
            <TextBtn2
              text={Dictionery.notFoundLink[lang.filename]}
              newType={4}
              link={`/${(lan ? "en" : "fa")}`}
            />
          </div>
          
        </div>
        <div className="navpad"></div>
      </Styles>
    </PageLayout>
  )
}

